import { __assign } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { formatNumber } from '../../formatting.js';
import styles from './ResourceImage.module.scss.js';

var typeToClass = {
    coal: { image: '', className: styles.coal },
    credits: { image: '', className: styles.credits },
    lootbox: { image: '', className: styles.lootbox },
    oil: { image: '', className: styles.oil },
    signals: { image: '', className: styles.signals },
    steel: { image: '', className: styles.steel },
    'cap-exp': { image: '', className: styles.capExp, textColor: '#98DEDE' },
};
var isCustom = function (props) {
    return props.image !== undefined;
};
var ResourceImage = function (props) {
    var _a;
    var customization = isCustom(props)
        ? { image: props.image, textColor: props.textColor, badgeColor: props.badgeColor }
        : typeToClass[props.type];
    var amount = (props === null || props === void 0 ? void 0 : props.amount) || 0;
    var amountBadge = (React.createElement("div", { className: classNames(styles.amountBadge, (_a = {},
            _a[styles.single] = !!(props === null || props === void 0 ? void 0 : props.single),
            _a[styles.small] = amount >= 1e6,
            _a[styles.xlSmall] = amount >= 1e7,
            _a)), style: {
            color: (customization === null || customization === void 0 ? void 0 : customization.textColor) || '#fff',
            backgroundColor: (customization === null || customization === void 0 ? void 0 : customization.badgeColor) || '#212222',
        } }, formatNumber(amount)));
    var style = __assign({}, props.styles);
    if (customization.image) {
        style['backgroundImage'] = "url(" + customization.image + ")";
    }
    return (React.createElement("div", { className: classNames(styles.resourceImage, customization === null || customization === void 0 ? void 0 : customization.className, props === null || props === void 0 ? void 0 : props.className), style: style }, amountBadge));
};

export { ResourceImage as default };
//# sourceMappingURL=ResourceImage.js.map
